<template>
  <b-row>
    <b-col
      class="raft-js-filter-cols"
      v-for="filterData in getFilters"
      :key="filterData.key"
    >
      <component
        v-if="getComponent(filterData.type, filterData.displaySettings.type)"
        :is="getComponent(filterData.type, filterData.displaySettings.type)"
        :filter-data="filterData"
        @update-filters="updateFilters"
      />
    </b-col>
  </b-row>
</template>

<script>
import BoolFilter from "../filters/display_mode_based/BoolFilter.vue";
import HasReferenceFilter from "../filters/display_mode_based/HasReferenceFilter.vue";
import ListFilter from "../filters/display_mode_based/ListFilter.vue";
import OgStandardRefFilter from "../filters/display_mode_based/OgStandardRefFilter.vue";
import StringFilter from "../filters/display_mode_based/StringFilter.vue";

require("vue-multiselect/dist/vue-multiselect.min.css");

export default {
  name: "FilterRow",
  components: {
    BoolFilter,
    HasReferenceFilter,
    ListFilter,
    OgStandardRefFilter,
    StringFilter,
  },
  data() {
    return {
      filterValues: {},
    };
  },
  props: {
    filters: {
      type: Array,
      required: true,
    },
    colsPerRow: {
      type: Number,
      required: true,
    },
  },
  computed: {
    colStyle: function () {
      const width = 100 / this.colsPerRow - 0.25;
      return {
        width: width + "%",
        float: "left",
      };
    },
    getFilters: function () {
      const filters = [];
      this.filters.forEach((filterData) => {
        if (!filterData.hasOwnProperty("displaySettings")) {
          filterData.displaySettings = {};
        }
        if (
          this.getComponent(filterData.type, filterData.displaySettings.type)
        ) {
          filters.push(filterData);
        }
      });
      return filters;
    },
  },
  methods: {
    getTypeToComponentMap: function (fieldType, displayType) {
      switch (fieldType) {
        case "string":
          return StringFilter;

        case "boolean":
          return BoolFilter;

        case "list_integer":
        case "list_string":
          return ListFilter;

        case "og_standard_reference":
          return OgStandardRefFilter;

        case "entity_reference":
          if (displayType === "entity_reference_has_entity_reference") {
            return HasReferenceFilter;
          }
          break;

        default:
          return null;
      }
    },
    getComponent: function (fieldType, displayType) {
      const component = this.getTypeToComponentMap(fieldType, displayType);
      return typeof component !== "undefined" ? component : false;
    },
    updateFilters: function (fieldName, value, operator) {
      let filterName = fieldName;
      filterName = filterName.replace(/[._]/g, "-") + "-filter";
      this.filterValues[fieldName] = {
        name: filterName,
        value: value,
        operator: operator,
      };
      this.$emit("update-filters", this.filterValues);
    },
  },
};
</script>

<style scoped>
div.row {
  width: 100%;
  display: inline-block;
}
</style>
